import { render, staticRenderFns } from "./Wap_LLMD01_Step2.vue?vue&type=template&id=1222c905&scoped=true&"
import script from "./Wap_LLMD01_Step2.vue?vue&type=script&lang=js&"
export * from "./Wap_LLMD01_Step2.vue?vue&type=script&lang=js&"
import style0 from "./Wap_LLMD01_Step2.vue?vue&type=style&index=0&id=1222c905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222c905",
  null
  
)

export default component.exports